module.exports = __webpack_public_path__ + "img/sketch2.6b508e3d.jpg";